<template>
    <div v-if="isLoaded">
        <div class="page-wrapper">
            <div class="page-content">
                <TopBar></TopBar>
                <div v-if="content" class="content-wrapper">
                    <div class="leaderboard-banner">
                        <img :src="content.banner" alt="">
                    </div>
                    <div class="text-title">
                        {{content.title}}
                    </div>
                    <div class="condition-text" @click="showCondition()">
                        คลิกที่นี่เพื่อดูเงื่อนไขกิจกรรม
                    </div>
                    <div 
                        class="list-wrapper"
                        v-for="(item) in content.leaderList"
                        :key="item.id"
                    >
                        <div v-if="item.enable">
                            <div class="background-item" :class="item.backgroundColor">
                                <div class="header-wrapper" :class="item.backgroundColor">
                                    <div class="header-title">
                                        {{item.skinTypeText}}
                                    </div>
                                </div>
                                <div class="list-content-wrapper">
                                    <div class="list-content-height">
                                        <!-- user list -->
                                        <div v-if="item.skinType == oilyUserList.type">
                                            <div v-for="(content, key) in oilyUserList.users" :key="key" >
                                                <div class="content-item">
                                                    <div class="item-number">{{key + 1}}</div>
                                                    <div class="item-name">
                                                        <div class="img-bg">
                                                            <img class="item-img" :src="content.PictureUrl" alt="">
                                                        </div>
                                                        <span class="text">{{displayName(content.Name)}}</span>
                                                    </div>
                                                    <div class="item-point">
                                                        <span>{{getPoints(content.Points)}}</span>
                                                        <img class="item-img" src="@/assets/bg/leaderboard/ic-points.svg" alt="">
                                                    </div>
                                                </div>
                                                <div class="divider"/>
                                            </div>
                                        </div>

                                        <div v-if="item.skinType == dehydratedUserList.type">
                                            <div v-for="(content, key) in dehydratedUserList.users" :key="key" >
                                                <div class="content-item">
                                                    <div class="item-number">{{key + 1}}</div>
                                                    <div class="item-name">
                                                        <div class="img-bg">
                                                            <img class="item-img" :src="content.PictureUrl" alt="">
                                                        </div>
                                                        <span class="text">{{displayName(content.Name)}}</span>
                                                    </div>
                                                    <div class="item-point">
                                                        <span>{{getPoints(content.Points)}}</span>
                                                        <img class="item-img" src="@/assets/bg/leaderboard/ic-points.svg" alt="">
                                                    </div>
                                                </div>
                                                <div class="divider"/>
                                            </div>
                                        </div>

                                        <div v-if="item.skinType == sensitiveUserList.type">
                                            <div v-for="(content, key) in sensitiveUserList.users" :key="key" >
                                                <div class="content-item">
                                                    <div class="item-number">{{key + 1}}</div>
                                                    <div class="item-name">
                                                        <div class="img-bg">
                                                            <img class="item-img" :src="content.PictureUrl" alt="">
                                                        </div>
                                                        <span class="text">{{displayName(content.Name)}}</span>
                                                    </div>
                                                    <div class="item-point">
                                                        <span>{{getPoints(content.Points)}}</span>
                                                        <img class="item-img" src="@/assets/bg/leaderboard/ic-points.svg" alt="">
                                                    </div>
                                                </div>
                                                <div class="divider"/>
                                            </div>
                                        </div>

                                        <div v-if="item.skinType == dryUserList.type">
                                            <div v-for="(content, key) in dryUserList.users" :key="key" >
                                                <div class="content-item">
                                                    <div class="item-number">{{key + 1}}</div>
                                                    <div class="item-name">
                                                        <div class="img-bg">
                                                            <img class="item-img" :src="content.PictureUrl" alt="">
                                                        </div>
                                                        <span class="text">{{displayName(content.Name)}}</span>
                                                    </div>
                                                    <div class="item-point">
                                                        <span>{{getPoints(content.Points)}}</span>
                                                        <img class="item-img" src="@/assets/bg/leaderboard/ic-points.svg" alt="">
                                                    </div>
                                                </div>
                                                <div class="divider"/>
                                            </div>
                                        </div>
                                        <!--end user list -->
                                    </div>
                                </div>
                                <div class="product-image-wrapper">
                                    <img :src="getImageBlob(item.skinType)" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
import Vue from "vue";
// component
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
// service
import LeaderBoardApi from '../service/LeaderBoardApi'
// mixin
import ModalMixin from '../../../mixin/ModalMixin'
import LocaleMixin from '../../../mixin/LocaleMixin'
// helper
import Util from '@/helper/Utility'
import ConfigManager from '@/config/ConfigManager';

export default {
    name: "LeaderBoard",
    mixins: [ModalMixin, LocaleMixin],
    components: { 
        TopBar 
    },
    data: function () {
        return {
            isLoaded: false,
            content: null,
            skinType:["oily", "dehydrated", "sensitive","dry"],
            oilyUserList: {
                users: [],
                type: "oily"
            },
            dehydratedUserList: {
                users: [],
                type: "dehydrated"
            },
            sensitiveUserList: {
                users: [],
                type: "sensitive"
            },
            dryUserList: {
                users: [],
                type: "dry"
            },
            busModal: new Vue(),
            condition: '',
        }
    },
    computed: {
    },
    created:async function() {
        this.loadingModal.show();
        await this.getLeaderBoardBlob();
        await this.getLeaderBoardConditionBlob();
        for (let i = 0; i < this.skinType.length; i++) {
            let catagory = this.skinType[i];
            let enable = this.content.leaderList.find((item) => item.enable && catagory == item.skinType)
            if (enable) {
                await this.getLeaderBoardApi(catagory);
            }
        }
        this.loadingModal.hide();
    },
    mounted: function() {
    },
    methods: {
        setupModalCompleted: function(){
            this.initialOtherModal();
        },
        getImageBlob: function(type) {
            var image = ConfigManager.getBlobUrl() + `/webconfig/bioderma/leaderboard/product_image/${type}.png`;
            return image;
        },
        displayName: function(name) {
            let formatName = name;
            formatName = formatName.substring(formatName, formatName.length - 3);
            return formatName + 'xxx'
        },
        getPoints: function(point) {
            return Util.formatNum(point);
        },
        getLeaderBoardBlob: function() {
            return new Promise((resolve) => {
                LeaderBoardApi.apiGetLeaderBoardBlob().subscribe((data) => {
                    this.content = data;
                    resolve(true);
                    this.isLoaded = true;
                }, (err) => {
                    console.log(err);
                    resolve(false);
                    this.isLoaded = true;
                })
            }) 
        },
        getLeaderBoardConditionBlob: function() {
            return new Promise((resolve) => {
                LeaderBoardApi.apiGetLeaderBoardConditionBlob().subscribe((data) => {
                    this.condition = data;
                    resolve(true);
                    this.isLoaded = true;
                }, (err) => {
                    console.log(err);
                    resolve(false);
                    this.isLoaded = true;
                })
            }) 
        },
        getLeaderBoardApi: function(catagory) {
            return new Promise((resolve) => {
                LeaderBoardApi.apiGetLeaderBoarder(catagory).subscribe((data) => {
                    switch (data.type) {
                        // requiement ให้แสดงไม่เกิน 40 user
                        case "oily":
                            for (let i = 0; i < data.data.length; i++) {
                                this.oilyUserList.users.push(data.data[i]);
                                if(this.oilyUserList.users.length == 40) break;
                            }
                            break;
                        case "dehydrated":
                            for (let i = 0; i < data.data.length; i++) {
                                this.dehydratedUserList.users.push(data.data[i]);
                                if(this.dehydratedUserList.users.length == 40) break;
                            }
                            break;
                        case "sensitive":
                            for (let i = 0; i < data.data.length; i++) {
                                this.sensitiveUserList.users.push(data.data[i]);
                                if(this.sensitiveUserList.users.length == 40) break;
                            }
                            break;
                        case "dry":
                            for (let i = 0; i < data.data.length; i++) {
                                this.dryUserList.users.push(data.data[i]);
                                if(this.dryUserList.users.length == 40) break;
                            }
                            break;
                    }
                    resolve(true);
                    this.isLoaded = true;
                }, (err) => {
                    console.log(err);
                    resolve(false);
                    this.isLoaded = true;
                })
            }) 
        },
        showCondition: function() {
            this.leaderBoardConditionModal            
                .clearText()
                .setTitle('เงื่อนไขของกิจกรรม')
                .setMsg(this.condition)
                .setBtnOk('ปิด')
                .show()
        }
    }
}
</script>

<style lang='scss' scoped>
    @import "@/style/base/base.scss";
    @import "../../../style/base/baseDisplay.scss";
    @import "../style/LeaderBoard.scss";

    .wrapper-campaign {
        padding: 15px 25px 100px;
        background-color: $deep-blue;
    }
</style>